<template>
  <v-row>
    <v-col cols="12" sm="6" md="2" class="pr-sm-5">
      <BaseFormInput
        id-element="cep"
        placeholder="Inserir"
        v-model="value.cep"
        required
        :rules="[requiredInput, isValidCep]"
        validate-on-blur
        v-facade="maskCEP"
        label-text="CEP"
      />
    </v-col>
    <v-col cols="12" sm="6" class="pr-sm-5">
      <BaseFormInput
        id-element="address"
        placeholder="Inserir"
        v-model="value.logradouro"
        required
        :rules="[requiredInput]"
        label-text="Endereço"
      />
    </v-col>
    <v-col cols="12" sm="6" md="2" class="pr-sm-5">
      <BaseFormInput
        id-element="number"
        placeholder="Inserir"
        v-model="value.numero"
        required
        :rules="[requiredInput, maxLengthNumber]"
        label-text="Número"
      />
    </v-col>
    <v-col cols="12" sm="6" md="2" class="pr-sm-5 pr-md-0">
      <BaseFormInput
        id-element="complement"
        placeholder="Inserir"
        v-model="value.complemento"
        label-text="Complemento"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pr-sm-5">
      <BaseFormSelect
        ref="ufSelect"
        id-element="uf"
        placeholder="Selecione"
        v-model="value.uf"
        :items="brazilianStates"
        required
        :rules="[requiredInput]"
        label-text="UF"
        item-text="nome"
        item-value="sigla"
        :return-object="true"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pr-sm-5">
      <BaseFormInput
        id-element="city"
        placeholder="Inserir"
        v-model="value.cidade"
        required
        :rules="[requiredInput]"
        label-text="Cidade"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pr-sm-5 pr-md-0">
      <BaseFormInput
        id-element="neighborhood"
        placeholder="Inserir"
        v-model="value.bairro"
        required
        :rules="[requiredInput]"
        label-text="Bairro"
      />
    </v-col>
  </v-row>
</template>

<script>
import { maskCPFCNPJ, maskCEP } from "@/utils/masks.js";
import { requiredInput, isValidCep, maxLengthNumber } from "@/utils/rules.js";
import { brazilianStates } from "@/utils/utils.js";

export default {
  name: "AddressFormSection",
  props: { value: { type: Object } },
  data() {
    return {
      requiredInput,
      brazilianStates,
      maskCPFCNPJ,
      maskCEP,
      isValidCep,
      maxLengthNumber
    };
  }
};
</script>
